import React from "react";
import { css } from "@emotion/react";

import { BRICKS } from "@titelmedia/bricks";

const Quote = (props) => {
  return (
    
      <BRICKS.elements.Quote {...props} />
    
  );
};

export default Quote;
